import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import WebView from "../views/WebView.vue"
import ResultView from "../views/ResultView.vue"
Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "home",
    component: HomeView,
}, {
    path: "/web",
    name: "web",
    component: WebView,
}, {
    path: "/result",
    name: "result",
    component: ResultView,
}];

const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;